import Text, { TextProps } from '../Text'

const PanelSectionTitle: FC<TextProps> = ({ children, className, ...props }) => {
  return (
    <Text
      $fontSize='sm'
      $fontWeight='medium'
      $color={'grayscale.700'}
      $lineHeight='none'
      className={className}
      {...props}
    >
      {children}
    </Text>
  )
}

export default PanelSectionTitle
